"use client";

import { RepackifyMark } from "@/components/brand/repackify-logo";
import { Button } from "@/components/ui/button";
import { HIDDEN_BESIDE_HERO_ASK } from "@/components/layout/hero-ask-visibility";
import { cn } from "@/lib/utils";

export function AskRepackifyChip({ onClick }: { onClick: () => void }) {
  return (
    <Button variant="chip" size="chip" className={cn("ml-2 shrink-0", HIDDEN_BESIDE_HERO_ASK)} onClick={onClick}>
      <RepackifyMark alt="" className="h-4" />
      <span className="max-sm:sr-only">Ask Repackify</span>
      <span className="sm:hidden" aria-hidden>
        Ask
      </span>
    </Button>
  );
}
